import { createSlice } from '@reduxjs/toolkit';
import { clearState } from './clearSlice';

const initialState = {
    selectedMentionedUser: null,
    isVisible: false,
};

const selectedUserSlice = createSlice({
    name: 'selectedUserData',
    initialState,
    reducers: {
        setMentionedUserInfo(state, action) {
            state.selectedMentionedUser = action.payload;
            state.isVisible = true;
        },
        clearMentionedUserInfo(state) {
            state.selectedMentionedUser = null;
            state.isVisible = false;
        },
        toggleMentionedUserInfoVisibility(state) {
            state.isVisible = !state.isVisible;
        },
    },
    extraReducers: builder => {
        builder.addCase(clearState, () => initialState);
    },
});

export const { setMentionedUserInfo, clearMentionedUserInfo, toggleMentionedUserInfoVisibility } =
    selectedUserSlice.actions;

export default selectedUserSlice.reducer;
